import useWishlist from "api/wishlistResource/useWishlist";
import { BookListItem, CustomPaginator } from "components";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";
import AccountLayout from "pages2/MyAccount/AccountLayout";
import useProfile from "api/UserResource/useProfile";
import { useState } from "react";
import { HiHeart } from "react-icons/hi";

const Wishlist = () => {
	const [page, setPage] = useState(1);
	const [firstPage, setFirstPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(40);
	const { data: profile, isLoading: isLoadingProfile } = useProfile();
	const { data: wishlistData, isLoading: isLoadingWishlist } = useWishlist({
		page,
		rows_per_page: rowsPerPage,
	});

	const books = wishlistData?.data?.records ?? [];
	const totalRecords = wishlistData?.data?.total_records ?? 0;
	const totalPages = wishlistData?.data?.total_pages ?? 1;

	const handlePageChange = (newPage) => setPage(newPage);
	const handleFirstPageChange = (newFirst) => setFirstPage(newFirst);
	const handleRowsPerPageChange = (newRows) => setRowsPerPage(newRows);

	const isEmpty = !isLoadingWishlist && books.length === 0;

	return (
		<Container>
			<div className="min-h-screen bg-gray-50">
				<div className="pt-8 pb-16">
					<PaddingX>
						<AccountLayout isLoading={isLoadingProfile} profile={profile?.data}>
							<div className="mb-10">
								<h1 className="text-2xl font-semibold text-gray-900">My Wishlist</h1>
								<p className="mt-1 text-sm text-gray-500">
									Books you've saved for later. Click "Remove" on any book to remove it from your
									wishlist.
								</p>
							</div>

							{isLoadingWishlist ? (
								<div className="flex justify-center py-16">
									<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-akgreen" />
								</div>
							) : isEmpty ? (
								<div className="flex flex-col items-center justify-center py-16 px-4 bg-gray-50 rounded-2xl border-2 border-dashed border-gray-200">
									<HiHeart className="w-16 h-16 text-gray-300 mb-4" />
									<h2 className="text-lg font-medium text-gray-700 mb-2">Your wishlist is empty</h2>
									<p className="text-gray-500 text-center max-w-sm">
										Browse our collection and click "Add to wishlist" on any book to add it here.
									</p>
								</div>
							) : (
								<>
									<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-6">
										{books.map((book) => (
											<BookListItem
												key={book.id}
												bookId={book.id}
												coverUrl={book?.book_cover?.url}
												title={book?.title}
												author={book?.author}
												price={book?.price}
												zwl_price={book?.zwl_price}
												rating={book?.rating}
												sellable={book?.sellable}
												isFree={book?.isFree}
												format={book?.format}
												showWishlist={true}
												isInWishlist={true}
											/>
										))}
									</div>

									{totalPages > 1 && (
										<div className="mt-8 pt-6 border-t">
											<CustomPaginator
												firstPage={firstPage}
												setFirstPage={handleFirstPageChange}
												rowsPerPage={rowsPerPage}
												setRowsPerPage={handleRowsPerPageChange}
												totalRecords={totalRecords}
												setPage={handlePageChange}
												showRowsPerPageDropdown={false}
											/>
										</div>
									)}
								</>
							)}
						</AccountLayout>
					</PaddingX>
				</div>
			</div>
		</Container>
	);
};

export default Wishlist;
